import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../utils/datetime';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useDataTableContext } from '../../Contexts/DataTableContext';
import { useTitle } from '../../../config/global';
import { INVITATIONS_TABLE_CONFIG } from '../../../Constants/datatables';

const InvitationsDataTable = () => {
    const { t } = useTranslation();
    useTitle('Users');
    const { totalRecords, loading, lazyParams, setLazyParams, data, onPage, onSort, onFilter, } = useDataTableContext();

    useEffect(() => {
        setLazyParams(prev => ({
            ...prev, ...INVITATIONS_TABLE_CONFIG
        }))
    }, [])

    const statusBodyTemplate = (rowData) => {

        return (
            <div className=''>
                <span className={` badge ${rowData.status == "ACCEPTED" ?
                    "bg-label-success"
                    : rowData.status == "PENDING" ? "bg-label-warning" :
                        "bg-label-danger"} `}>
                    {rowData.status.toLowerCase()}
                </span>
            </div>
        );
    }

    const dateBodyTemplate = (rowData) => {
        return formatDateTime(rowData.created_at);
    }

    return (
        < >
            <div className='table-responsive text-nowrap'>
                <DataTable value={data?.invitations} lazy filterDisplay="row" responsiveLayout="scroll" dataKey="id"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[15, 25, 50, 100]}
                    totalRecords={totalRecords} onPage={onPage} scrollable scrollHeight="69vh"
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter} filters={lazyParams.filters} loading={loading} className="table"
                >
                    <Column
                        field="email"
                        header={t('table.email')}
                        sortable
                        filter
                        className='text-center' />
                    <Column header={t('table.status')} filterField="status"
                        body={statusBodyTemplate}
                        showFilterMatchModes={false} filterMenuStyle={{ width: '14rem' }}
                        style={{ minWidth: '14rem' }}
                        filter sortable
                        className='text-center' />
                    <Column
                        header={t('users.created_date')}
                        filterField="created_at"
                        dataType="date"
                        style={{ minWidth: '10rem' }}
                        body={dateBodyTemplate}
                        sortable />
                </DataTable>
            </div>
        </ >
    );
}
export default InvitationsDataTable;
